import React, { useState, useEffect } from "react";

import LightGallery from "lightgallery/react";
import ImgAdven from "../assest/images/banner-img/separtor.png";
import flagImg from "../assest/images/car-img/flg.png";

import carImg2 from "../assest/images/faq-img/hotballon-right.png";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Import LightGallery plugins
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

// Image imports
import aboutImg from "../assest/images/about-us/about-img.png";
import customerImg from "../assest/images/about-us/customer-img-grp.png";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import { useLocation } from "react-router-dom";
import Loader from "../component/loader.jsx";

function Rental() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [rentdata, setRentData] = useState([]);

  const RentalData = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("rental");
      setIsLoading(false);
      if (res?.success) {
        setRentData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const icon = (color) =>
    new L.Icon({
      iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-${color}.png`,
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
    });

  const leh = [{ name: "Leh City", pos: [34.1526, 77.5771] }];

  const nubra = [{ name: "Nubra Valley", pos: [34.5944, 77.503] }];

  const pangong = [{ name: "Pangong Lake", pos: [33.7333, 78.8867] }];

  const tsoMoriri = [{ name: "Tso Moriri Lake", pos: [32.9, 78.3] }];

  const kargilRoute = [
    [34.1526, 77.5771],
    [34.5539, 76.134],
    [34.0837, 74.7973],
  ];

  useEffect(() => {
    RentalData();
  }, []);

  const [formData, setFormData] = useState({
    user_name: "",
    email: "",
    mobile_number: "",
    date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!selectedItem) {
      errorAlert("No item selected for booking.");
      setIsLoading(false);
      return;
    }

    const payload = {
      category: selectedItem.category,
      name: selectedItem.title,
      price: selectedItem.price,
      user_name: formData.user_name,
      email: formData.email,
      mobile_number: formData.mobile_number,
      date: formData.date,
    };

    try {
      const res = await apiRequest("rental-enq", "POST", payload);
      setIsLoading(false);
      if (res?.status) {
        successAlert(res.message || "Inquiry submitted successfully!");
        closeModal();
      } else {
        errorAlert(res.message || "Failed to submit inquiry.");
      }
    } catch (error) {
      setIsLoading(false);
      errorAlert("An error occurred while submitting the inquiry.");
      console.error("Inquiry error", error);
    }
  };

  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
    // Reset form data when opening modal
    setFormData({ user_name: "", email: "", mobile_number: "", date: "" });
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const taxiRates = [
    {
      tour: "Leh Local Sightseeing",
      aPlus: "₹18,000",
      a: "₹16,000",
      b: "₹14,000",
      c: "₹12,000",
    },
    {
      tour: "Leh to Nubra Valley",
      aPlus: "₹28,000",
      a: "₹25,000",
      b: "₹22,000",
      c: "₹20,000",
    },
    {
      tour: "Leh to Pangong Lake",
      aPlus: "₹30,000",
      a: "₹27,000",
      b: "₹24,000",
      c: "₹21,000",
    },
    {
      tour: "Leh – Nubra – Pangong",
      aPlus: "₹45,000",
      a: "₹40,000",
      b: "₹36,000",
      c: "₹32,000",
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {/* Inquiry Modal */}

      {isModalOpen && selectedItem && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>

                <h4>Get a Quote for: {selectedItem.title}</h4>

                {/* <p>
                  Price: <strong>₹ {selectedItem.price} / day</strong>
                </p> */}

                <form onSubmit={handleSubmit}>
                  <div className="row enquiry_row">
                    {/* NAME */}

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="required">Full name</label>

                        <input
                          className="form-control"
                          name="user_name"
                          placeholder="Your full name"
                          value={formData.user_name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* PHONE */}

                    <div className="col-md-6">
                      <label className="required">Phone number</label>

                      <input
                        type="tel"
                        className="form-control"
                        name="mobile_number"
                        placeholder="9999955555"
                        value={formData.mobile_number}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* DATE */}

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="required">
                          Preferred travel date
                        </label>

                        <input
                          type="date"
                          className="form-control"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* EMAIL */}

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="required">Email</label>

                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="youremail@domain.com"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* SUBMIT */}

                    <div className="col-12 text-center mt-3">
                      <button className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit Inquiry"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fulid">
        <div className="map-wrapper">
          <MapContainer center={[34.3, 77.8]} zoom={7} className="map">
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

            {/* Leh */}
            {leh.map((l, i) => (
              <Marker key={i} position={l.pos} icon={icon("red")}>
                <Popup>{l.name}</Popup>
              </Marker>
            ))}

            {/* Nubra */}
            {nubra.map((l, i) => (
              <Marker key={i} position={l.pos} icon={icon("violet")}>
                <Popup>{l.name}</Popup>
              </Marker>
            ))}

            {/* Pangong */}
            {pangong.map((l, i) => (
              <Marker key={i} position={l.pos} icon={icon("blue")}>
                <Popup>{l.name}</Popup>
              </Marker>
            ))}

            {/* Tso Moriri */}
            {tsoMoriri.map((l, i) => (
              <Marker key={i} position={l.pos} icon={icon("green")}>
                <Popup>{l.name}</Popup>
              </Marker>
            ))}

            {/* Route Line */}
            <Polyline positions={kargilRoute} color="brown" weight={4} />
          </MapContainer>

          {/* RIGHT LEGEND */}
          <div className="legend-box">
            <h4>Interactive map</h4>
            <p>🔴 Leh</p>
            <p>🟣 Nubra valley</p>
            <p>🔵 Pangong lake</p>
            <p>🟢 Tso Moriri</p>
            <p>🟤 Kargil - Srinagar</p>
          </div>

          {/* BOTTOM LEGEND */}
          <div className="bottom-legend">
            <span>🔴 Leh</span>
            <span>🟠 Indus valley (East)</span>
            <span>🟢 Indus valley (West)</span>
            <span>🟣 Nubra valley</span>
            <span>🔵 Pangong lake</span>
            <span>🟢 Tso Moriri</span>
            <span>🟤 Kargil, Srinagar</span>
            <span>🟡 Zanskar valley</span>
          </div>
        </div>
      </div>

      <section className="home-destination">
        <div className="container">
          <div className="row">
            {/* LEFT CONTENT */}

            <div className="col-lg-6">
              <div
                className="about-content"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* TITLE */}

                <div className="section-title mb-40">
                  <span>Services</span>

                  <h2>Car Bike Services</h2>

                  <img src={ImgAdven} alt="" />
                </div>

                <p>
                  Below is the revised price of bikes in Ladakh Considering the
                  types of road and the beating a motorcycle takes on these
                  roads, The Bike Rental Rates in Ladakh is pretty reasonable.
                  Please refer the table below for the rates and types of
                  motorcycle you want to hire. Renting a bike in Ladakh is
                  simple as producing your driving licence, and another identity
                  card. But keep in mind though; that these roads are tricky and
                  fewer people find themselves in a ditch. You have to be
                  mindful about how to Ride In Ladakh especially when there is
                  sand on the road. Any bike rental company will charge you for
                  the damages on a bike if there is any, and it is important to
                  bring your own gears for the ride, otherwise, we provide them
                  as well. The Cost Of Hiring A Bike is so little when you
                  realise the freedom that a four-wheeler is limited to. We at
                  Mototour Ladakh highly recommend people who are travelling
                  solo to rent a motorcycle and don't let the itinerary take its
                  toll on your freedom.
                </p>

                {/* TABS */}

                {/* BOTTOM */}

                <div className="about-content-bottom mt-5">
                  <a href="/about" className="round-btn">
                    More info
                  </a>

                  <div className="counter-area d-flex align-items-center">
                    <div className="customer-img-grp">
                      <img src={customerImg} alt="customers" />
                    </div>

                    <div className="content ms-2">
                      <div className="number d-flex">
                        <h6 className="counter">500</h6>

                        <span>+</span>
                      </div>

                      <p>Customer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}

            <div className="col-lg-6 d-flex justify-content-end">
              <div className="about-img">
                <img src={aboutImg} alt="about" />

                {/* <img src={vectorImg} className="vector" alt="vector" /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*gallary-section-start*/}

      <section className="home-gallery home-destination bg-light">
        <div className="flag-img">
          <img src={flagImg} alt="" />
        </div>

        <div className="flag-img-1">
          <img
            className="media-right-ballon move-21 move-2"
            src={carImg2}
            alt=""
          />
        </div>

        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Gallary</span>

                <h2>PHOTO'S FROM BIKERS</h2>

                <img src={ImgAdven} alt="" />
              </div>
            </div>
          </div>

          <LightGallery
            plugins={[lgZoom, lgThumbnail]}
            speed={500}
            // आपका वही पुराना डिज़ाइन क्लास

            elementClassNames="gallery-grid gallary-grid-1"
          >
            {/* images की जगह अब homeData पर मैप चलेगा */}

            {rentdata && rentdata.length > 0 ? (
              rentdata.map((item, i) => (
                <a
                  key={i}
                  href={`${BASE_URL}${item.image}`}
                  // डिज़ाइन को बरकरार रखते हुए 3 के बाद वाली इमेजेज को छुपाया गया है

                  className={`item-${i + 1} ${i >= 3 ? "d-none" : ""}`}
                >
                  <img src={`${BASE_URL}${item.image}`} alt={`travel-${i}`} />
                </a>
              ))
            ) : (
              <p>Loading...</p>
            )}
          </LightGallery>
        </div>
      </section>

      {/*gallary-section-end*/}

      {/*gallary-section-start*/}

      <section className="home-gallery home-destination">
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Your Ride. Your Route</span>

                <h2>Our Premium Bike Rental Fleet</h2>

                <img src={ImgAdven} alt="" />
              </div>
            </div>
          </div>

          <div className="row">
            {rentdata

              ?.filter((item) => item.category === "bike") // सिर्फ bike वाली category

              .map((item, index) => (
                <div className="col-lg-4" key={index}>
                  <div className="bike-card mb-3">
                    <div className="bike-img">
                      <img
                        src={`${BASE_URL}${item.image}`}
                        alt={item.image_alt}
                      />
                    </div>

                    <div className="bike-content">
                      <h4>{item.title}</h4>

                      <h3 className="price">
                        ₹ {item.price}{" "}
                        <span>
                          {item.price_type === "per_day" ? "/ day" : ""}
                        </span>
                      </h3>

                      {/* API में short_description HTML स्ट्रिंग है */}

                      <div
                        className="bike-desc"
                        dangerouslySetInnerHTML={{
                          __html: item.short_description,
                        }}
                      />

                      <div className="bike-btns">
                        <button
                          onClick={() => openModal(item)}
                          className="book-btn btn btn-warning text-white w-100"
                        >
                          Book Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      <section className="home-gallery home-destination">
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Your Ride. Your Route</span>

                <h2>Our Premium Car Rental Fleet</h2>

                <img src={ImgAdven} alt="" />
              </div>
            </div>
          </div>

          {/* ================= A+ LUXURY ================= */}

          {rentdata?.filter(
            (i) => i.category === "car" && i.car_category === "A+",
          ).length > 0 && (
            <div className="category-wrapper">
              <div className="styled-heading-box">
                {/* <span className="sub-title">The Ultimate Experience</span> */}
                <span className="sub-title">A+ Luxury</span>

                <div className="title-separator"></div>

                {/* <h2 className="main-title">A+ Luxury</h2> */}
              </div>

              <div className="row">
                {rentdata

                  ?.filter(
                    (item) =>
                      item.category === "car" && item.car_category === "A+",
                  )

                  .map((item, index) => (
                    <div className="col-lg-4 mb-4" key={index}>
                      <div className="bike-card shadow-sm">
                        <div className="bike-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>

                        <div className="bike-content text-center">
                          <h4 className="mt-3">{item.title}</h4>

                          {/* <h3 className="price" style={{ color: "#f39c12" }}>
                            ₹ {item.price}{" "}
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              / day
                            </span>
                          </h3> */}

                          <div
                            className="bike-desc mb-3"
                            style={{ fontSize: "14px", color: "#777" }}
                            dangerouslySetInnerHTML={{
                              __html: item.short_description,
                            }}
                          />

                          <div className="bike-btns pb-3">
                            <button
                              onClick={() => openModal(item)}
                              className="book-btn btn btn-warning text-white w-100"
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {/* ================= A PREMIUM ================= */}

          {/* {rentdata?.filter(
            (i) => i.category === "car" && i.car_category === "A",
          ).length > 0 && (
            <div className="category-wrapper">
              <div className="styled-heading-box">
                <span className="sub-title">Top Notch Vehicles</span>

                <div className="title-separator"></div>
                <h2 className="main-title">A Premium</h2>
              </div>

              <div className="row">
                {rentdata

                  ?.filter(
                    (item) =>
                      item.category === "car" && item.car_category === "A",
                  )

                  .map((item, index) => (
                    <div className="col-lg-4 mb-4" key={index}>
                      <div className="bike-card shadow-sm">
                        <div className="bike-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>

                        <div className="bike-content text-center">
                          <h4 className="mt-3">{item.title}</h4>

                          <h3 className="price" style={{ color: "#f39c12" }}>
                            ₹ {item.price}{" "}
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              / day
                            </span>
                          </h3>

                          <div
                            className="bike-desc mb-3"
                            style={{ fontSize: "14px", color: "#777" }}
                            dangerouslySetInnerHTML={{
                              __html: item.short_description,
                            }}
                          />

                          <div className="bike-btns pb-3">
                            <button
                              onClick={() => openModal(item)}
                              className="book-btn btn btn-warning text-white w-100"
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )} */}

          {/* ================= B COMFORT ================= */}

          {rentdata?.filter(
            (i) => i.category === "car" && i.car_category === "B",
          ).length > 0 && (
            <div className="category-wrapper">
              <div className="styled-heading-box">
                {/* <span className="sub-title">Relaxing & Smooth Ride</span> */}
                <span className="sub-title">B Premium</span>

                <div className="title-separator"></div>
                {/* <h2 className="main-title">B Premium</h2> */}
              </div>

              <div className="row">
                {rentdata

                  ?.filter(
                    (item) =>
                      item.category === "car" && item.car_category === "B",
                  )

                  .map((item, index) => (
                    <div className="col-lg-4 mb-4" key={index}>
                      <div className="bike-card shadow-sm">
                        <div className="bike-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>

                        <div className="bike-content text-center">
                          <h4 className="mt-3">{item.title}</h4>

                          {/* <h3 className="price" style={{ color: "#f39c12" }}>
                            ₹ {item.price}{" "}
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              / day
                            </span>
                          </h3> */}

                          <div
                            className="bike-desc mb-3"
                            style={{ fontSize: "14px", color: "#777" }}
                            dangerouslySetInnerHTML={{
                              __html: item.short_description,
                            }}
                          />

                          <div className="bike-btns pb-3">
                            <button
                              onClick={() => openModal(item)}
                              className="book-btn btn btn-warning text-white w-100"
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {/* ================= C ECONOMY ================= */}

          {rentdata?.filter(
            (i) => i.category === "car" && i.car_category === "C",
          ).length > 0 && (
            <div className="category-wrapper">
              <div className="styled-heading-box">
                {/* <span className="sub-title">Budget Friendly Choice</span> */}
                <span className="sub-title">C Comfort</span>

                <div className="title-separator"></div>
                {/* <h2 className="main-title">C Comfort</h2> */}
              </div>

              <div className="row">
                {rentdata

                  ?.filter(
                    (item) =>
                      item.category === "car" && item.car_category === "C",
                  )

                  .map((item, index) => (
                    <div className="col-lg-4 mb-4" key={index}>
                      <div className="bike-card shadow-sm">
                        <div className="bike-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>

                        <div className="bike-content text-center">
                          <h4 className="mt-3">{item.title}</h4>

                          {/* <h3 className="price" style={{ color: "#f39c12" }}>
                            ₹ {item.price}{" "}
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              / day
                            </span>
                          </h3> */}

                          <div
                            className="bike-desc mb-3"
                            style={{ fontSize: "14px", color: "#777" }}
                            dangerouslySetInnerHTML={{
                              __html: item.short_description,
                            }}
                          />

                          <div className="bike-btns pb-3">
                            <button
                              onClick={() => openModal(item)}
                              className="book-btn btn btn-warning text-white w-100"
                            >
                              Book Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/*gallary-section-end*/}

      <section className="taxi-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-sm-center">
              <div className="section-heading">
                <div className="about-content">
                  <div className="section-title mb-40">
                    <span>Leh Ladakh Tours</span>

                    <h2>Taxi Rates 2026</h2>

                    <p>
                      Select your vehicle category & explore Ladakh comfortably
                    </p>

                    <img src={ImgAdven} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="table-wrapper table-responsive"></div>

          <div className="row">
            {taxiRates.map((item, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="taxi-card">
                  <h4 className="tour-title">{item.tour}</h4>

                  <div className="rate-list">
                    <div className="rate-item">
                      <span>Car A+</span>

                      <strong>{item.aPlus}</strong>

                      <small>Crysta / Scorpio-N / XUV700</small>
                    </div>

                    <div className="rate-item">
                      <span>Car A</span>

                      <strong>{item.a}</strong>

                      <small>Innova / Aria / XUV</small>
                    </div>

                    <div className="rate-item">
                      <span>Car B</span>

                      <strong>{item.b}</strong>

                      <small>Xylo / Scorpio / Ertiga</small>
                    </div>

                    <div className="rate-item">
                      <span>Car C</span>

                      <strong>{item.c}</strong>

                      <small>Sumo / Eeco / Qualis</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Rental;
